import React, { useState, useEffect, createContext } from "react";
import { useNavigate } from "react-router-dom";

import { api, createSession } from "../services/api";

import { resetPermissions } from "../components/Utils/groups";

import toast from "react-hot-toast";



export const AuthContext = createContext();

export const getSession = () => {
    return JSON.parse(localStorage.getItem('user'))
}


export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const recoveredUser = localStorage.getItem('user')

        if (recoveredUser) {
            setUser(JSON.parse(recoveredUser));
            resetPermissions()
        }

        setLoading(false);

    }, []);

    const login = async (username, password, engine = 'MICROUNIVERSO', redirect=true) => {

        const response = await createSession(username, password, engine)

        if (response.status === 206) {
            return toast.success('Um e-mail foi enviado para o usuário com a senha correspondente.')
        }
        if (response.status !== 200) {
            return toast.error('Usuário ou senha inválidos')
        }

        //const token = response.data.access_token
        const file_size = response.data.file_size

        const decode = response.data;
        const grupo = decode['Grupo']
        const user_id = decode['OID']
        const oid_enterprise = decode['OIDEnterprise']
        const vendedor = decode['Vendedor']

        const objLoggedUser = {
            "username": username,
            "id": user_id,
        }

        const loggedUser = objLoggedUser

        localStorage.setItem("user", JSON.stringify(decode?.Usuario));
        if (process.env.REACT_APP_USE_COOKIES === 'false')
            localStorage.setItem("token", decode.token)
        localStorage.setItem("user_id", user_id)
        localStorage.setItem("grupo", grupo)
        localStorage.setItem("vendedor", JSON.stringify(vendedor || {}))
        localStorage.setItem("oid_enterprise", oid_enterprise)
        localStorage.setItem("file_size", file_size)
        localStorage.setItem('engine', engine)

        //api.defaults.headers.Authorization = `Bearer ${decode.token}`

        resetPermissions()
        setUser(loggedUser);

        const hashValue = localStorage.getItem('hash');

        if ('invokeLogin' in window) window.invokeLogin(false)

        if ('login_callback' in window) window.login_callback()

        if (!redirect)
            return

        if (engine === 'ELEVOR')
            navigate(`/pelevor`)
        else if (hashValue) {
            navigate(`/distribuicao/r?hash=${hashValue}`);
        } else {
            navigate("/pedidos");
        }

    };

    const logout = () => {
        setUser(null)
        api.defaults.headers.Authorization = null;
        navigate("/login")
    };



    return (
        <AuthContext.Provider
            value={{ authenticated: !!user, user, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    )
};

